function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { MaterialTypes } from "../../enum/MaterialTypes";
/**
 * 素材情報(アップロード)モデル
 */

var UploadMaterialInstanceModel =
/**
 * コンストラクタ
 *
 */
function UploadMaterialInstanceModel() {
  _classCallCheck(this, UploadMaterialInstanceModel);

  this.SessionId = -1;
  this.MaterialFileName = "";
  this.DisplayFileName = "";
  this.MaterialType = MaterialTypes.Unknown;
  this.MaterialFileSize = 0;
  this.ItemCount = 0;
  this.Items = [];
};

export { UploadMaterialInstanceModel as default };